import { DialogForm, Form, useDialogExitWarning } from '@ais-ui/ui-core';
import React, { useState, useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { useGetShareGroups } from '@ais-ui/websockets';
import { ScheduleMessageFormValues } from './scheduleMessageForm';
import { ScheduleMessageForm } from './ScheduleMessageForm';

interface ScheduleMessageDialogProps {
  form: UseFormReturn<ScheduleMessageFormValues>;
  onSubmit: (data: ScheduleMessageFormValues) => void;
  mutateType: 'edit' | 'create';
  isSubmitting: boolean;
  setShowOuterDialog: (showOuterDialog: boolean) => void;
}

export const ScheduleMessageDialog = ({
  form,
  onSubmit,
  mutateType,
  isSubmitting,
  setShowOuterDialog,
}: ScheduleMessageDialogProps) => {
  const { messages } = useLocalization();
  const [showDialog] = useState<boolean>(true);
  const { data: groups, isLoading: isLoadingGroups } = useGetShareGroups();

  const handleConfirm = useCallback(() => {
    setShowOuterDialog(false);
  }, [setShowOuterDialog]);

  const { handleClose, ExitWarningDialog } = useDialogExitWarning({
    onConfirm: handleConfirm,
    title: messages.messageScheduleWarningTitle || 'Discard scheduled message?',
    description: messages.messageScheduleWarningDescription || 'Your scheduled message configuration will be lost. Are you sure you want to close?',
  });

  return (
    <Form {...form}>
      <DialogForm
        showDialog={showDialog}
        onOpenChange={setShowOuterDialog}
        title="Schedule message"
        isLoading={isLoadingGroups}
        hasLoaded={!isLoadingGroups && !!groups}
        buttonId="submit-schedule-message-button"
        buttonText={
          isSubmitting ? messages.genericSubmitting : messages.genericSubmit
        }
        buttonDisabled={isSubmitting}
        buttonOnClick={form.handleSubmit(onSubmit)}
        onClose={handleClose}
      >
        <ScheduleMessageForm
          form={form}
          mutateType={mutateType}
        ></ScheduleMessageForm>
      </DialogForm>
      <ExitWarningDialog />
    </Form>
  );
};
